import { useState } from 'react'

import useConfirmationModal from '~/hooks/useConfirmationModal'

/**
 * Confirmação de exclusão que guarda o que está para ser apagado: uma linha
 * (kebab) ou a seleção inteira (bulk bar). `fromSelection` diz qual das duas,
 * para a página só limpar a seleção quando ela é o que foi apagado.
 */
export const useConfirmDelete = <T>() => {
  const [ConfirmationModal, isOpen, , setIsOpen] = useConfirmationModal()
  const [items, setItems] = useState<T[]>([])
  const [fromSelection, setFromSelection] = useState(false)

  const ask = (next: T[], options: { fromSelection?: boolean } = {}) => {
    setItems(next)
    setFromSelection(!!options.fromSelection)
    setIsOpen(true)
  }

  const close = () => setIsOpen(false)

  return { ConfirmationModal, isOpen, items, fromSelection, ask, close }
}
